import { EMPTY, of } from 'rxjs';
import { concatMap } from 'rxjs/operators';
import { ofType } from 'redux-observable';
// ---- external imports -----

import { levelSelectors, levelActions } from '~/store';
import { LEVEL_UPDATE_MISSIONS } from '~/store/level/actionTypes';
// ---- internal imports ----


const checkInstantLevelFailEpic = (action$, state$) => action$.pipe(
	ofType(LEVEL_UPDATE_MISSIONS),
	concatMap(() => (checkInstantLevelFail(state$.value)))
);

function checkInstantLevelFail(state) {
    const missions = levelSelectors.getMissions(state);
	const shallFailLevelInstantly = missions.find((mission) => !!mission?.hasEvaluatedMission && !mission.completed);

	if (shallFailLevelInstantly) {
		return of(levelActions.levelFailed()); 
	}

	return EMPTY;
}


export default checkInstantLevelFailEpic;
